import React, { Component } from "react"
import ReactECharts from 'echarts-for-react'
import helper from "../../../../utils/helper"

class ChartPlanos extends Component {
    state = {
        configurationChart: {}
    }

    componentWillMount = () => {
       setTimeout(() => {
            const data = this.props.data

            const titlesChart = data.map((item) => item.plano)
            const dataChart = data.map((item) => ({ value: item.total_de_faturamento }))

            const configuration = {
                tooltip: {
                    formatter: (params) => {
                        return params.marker + helper.formatMoney(params.value);
                    }
                },
                xAxis: {
                    data: titlesChart
                },
                yAxis: {},
                animationDurationUpdate: 500,
                series: {
                    type: 'bar',
                    data: dataChart
                }
            }

            this.setState({configurationChart: configuration})
       }, 500)
    }
    
    render() {
        const { configurationChart } = this.state

        return (
            <ReactECharts
                option={configurationChart}
            />
        )
    }
}

export default ChartPlanos